/**
 * Entidad que representa un elemento del breadcrumb de navegación
 * Encapsula las reglas de negocio para la navegación entre capas de filtro
 */
export interface NavigationBreadcrumbEntity {
  readonly title: string;
  readonly path: string;
  readonly params?: Record<string, string>;
  readonly isFilterLayer: boolean;
}

/**
 * Entidad que representa el estado completo de navegación
 */
export interface NavigationStateEntity {
  readonly breadcrumbs: NavigationBreadcrumbEntity[];
  readonly currentTitle: string;
}

/**
 * Value Object para validar la navegación de capas de filtro
 */
export class FilterLayerNavigation {
  private static readonly FILTER_LAYER_PATHS = [
    '/sedes-panel/',
    '/carreras-panel/',
    '/estudiante',
    '/riesgo-academico',
    '/caracterizacion',
  ];

  static isFilterLayer(path: string): boolean {
    return this.FILTER_LAYER_PATHS.some((filterPath) =>
      path.includes(filterPath),
    );
  }

  static createBreadcrumb(
    title: string,
    path: string,
    params?: Record<string, string>,
  ): NavigationBreadcrumbEntity {
    return {
      title,
      path,
      params,
      isFilterLayer: this.isFilterLayer(path),
    };
  }

  static validateBreadcrumbStack(
    breadcrumbs: NavigationBreadcrumbEntity[],
  ): boolean {
    // Validar que las capas de filtro mantengan jerarquía correcta
    const filterLayers = breadcrumbs.filter((b) => b.isFilterLayer);

    // Home -> Centro -> Carrera -> Estudiantes -> Caracterización (máximo 4 capas de filtro)
    return filterLayers.length <= 4;
  }
}
